import { CharacterizationTypeEnum } from './enums';
import { CharacterizationFunctionPerformed } from './characterization-function-performed';

export class CharacterizeTestedPartyFunctionsPerformed {
  characterizationFunctionsPerformed: CharacterizationFunctionPerformed[];
  characterizationType = CharacterizationTypeEnum.FunctionsPerformed;
}
